module.exports = __webpack_public_path__ + "static/media/order_done.a9da8750.png";